// extracted by mini-css-extract-plugin
module.exports = {"deleteAccount":"Advanced_deleteAccount__cbLii"};